import React from 'react';
import { GenericEventType } from '@features/Calendar/constants';
import { useFormContext } from 'react-hook-form';
import DefaultInformation from './default-information';
import SiteVisitInformation from './site-visit-information';
import EventTypeSelector from './event-type-selector';
function BasicInformationSection() {
    const { watch } = useFormContext();
    const formValues = watch();
    return (React.createElement("div", { className: "basicInformationSection" },
        React.createElement(EventTypeSelector, null),
        React.createElement(DefaultInformation, null),
        formValues.eventType === GenericEventType.Site_visit && React.createElement(SiteVisitInformation, null)));
}
export default BasicInformationSection;
